import React from "react";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { useFormik } from "formik";
import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import RefreshIcon from "@mui/icons-material/Refresh";
import Button from "@mui/material/Button";

export const UpcomingToolbar = ({ search, setSearch, setIsLoading, setHighlightUpcoming, onSearch, onRefresh, onClearSearch, isBusy }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      search: "",
    },
    onSubmit: (fields) => {
      setIsLoading(true);
      setSearch(fields.search);
      onSearch(fields.search)
        .then((res) => {
          setHighlightUpcoming();
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    },
  });

  const refresh = () => {
    setIsLoading(true);
    onRefresh()
      .then((res) => {
        setHighlightUpcoming();
        setSearch("");
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  return (
    <form className="table-toolbar" onSubmit={formik.handleSubmit}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Button disabled={isBusy} sx={{ textTransform: "none" }} size="small" onClick={refresh} variant="outlined" startIcon={<RefreshIcon />}>
          {t("refresh")}
        </Button>
        {search && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            <div style={{ marginLeft: 10 }}></div>
            {t("search_results")} "{search}"{" "}
            <IconButton
              size="small"
              aria-label="upload picture"
              component="span"
              onClick={() => {
                onClearSearch()
                  .then((res) => {
                    setSearch("");
                  })
                  .catch((err) => {});
              }}
            >
              <CancelIcon />
            </IconButton>
          </div>
        )}
      </div>
      <TextField
        sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: 1, marginTop: 1 }}
        variant="outlined"
        size="small"
        id="search"
        name="search"
        value={formik.values.search}
        onChange={formik.handleChange}
        placeholder={t("search")}
        InputProps={{
          type: "search",
          startAdornment: <SearchIcon fontSize="medium" />,
        }}
      />
    </form>
  );
};
